import { useEffect, useMemo, useState } from 'react'

import { useRouter } from 'next/router'

import { MaximumResult, Locale } from '@/service/api/landingPage'
import { useScreen } from '@/store/screen'
import { getLPTranslationData } from '@/utils/getLPTranslationData'

export const useMaximumResults = () => {
  const { windowSize } = useScreen()

  const router = useRouter()
  const locale = (router.locale || 'pt-BR') as Locale
  const { asPath } = router

  const [maximumResultsData, setMaximumResultsData] = useState<MaximumResult>(
    () =>
      getLPTranslationData({
        landingPage: asPath === '/software' ? 'lp1' : 'lp2',
        container: 'maximumResultsContainer',
        locale,
      }) as MaximumResult,
  )

  useEffect(() => {
    const translationsObject = getLPTranslationData({
      landingPage: asPath === '/software' ? 'lp1' : 'lp2',
      container: 'maximumResultsContainer',
      locale,
    }) as MaximumResult

    setMaximumResultsData(translationsObject)
  }, [locale, asPath])

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        title: 'h4' as const,
        subtitle: 'b2' as const,
      },
      791: {
        title: 'b2' as const,
        subtitle: 'b4' as const,
      },
    }
    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]
    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
    maximumResultsData,
  }
}
